module.exports = __webpack_public_path__ + "static/media/PaydayLoan-Icon.03073b7c.svg";